export default function NotificationsBar() {
  return (
    <div
      style={{
        background: "#FFD700",
        overflow: "hidden",
        whiteSpace: "nowrap",
        padding: "10px",
        fontWeight: "bold",
      }}
    >
      <marquee scrollamount="6">
        Broad Aim of the Course:
        To create future teachers with commitment, competencies, professional skills and values capable of building a humane, healthy and learning society
      </marquee>
    </div>
  );
}